module.exports = __webpack_public_path__ + "static/rulebg.69637597.png";